import { ComponentProps, FC } from 'react'
import { IconButton } from '../../IconButton'
import { DropdownPrimitives } from './Dropdown'
import { DropdownDefaultTrigger } from './DropdownDefaultTrigger'

export const Trigger: FC<
  ComponentProps<typeof DropdownPrimitives.Trigger> & {
    iconButtonProps?: ComponentProps<typeof IconButton>
  }
> = ({ children, iconButtonProps = {}, ...rest }) => {
  return (
    <DropdownPrimitives.Trigger asChild {...rest}>
      {children ?? <DropdownDefaultTrigger {...iconButtonProps} />}
    </DropdownPrimitives.Trigger>
  )
}
